/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightSupportNextAction
 */
export interface FlightSupportNextAction {
    /**
     * Bounded safe next action derived only from persisted evidence; "none" means no action is required.
     * @type {string}
     * @memberof FlightSupportNextAction
     */
    action: FlightSupportNextActionActionEnum;
    /**
     * Bounded owner for the next action; "none" accompanies action=none.
     * @type {string}
     * @memberof FlightSupportNextAction
     */
    owner: FlightSupportNextActionOwnerEnum;
    /**
     * Bounded explanation for the next action; this field is never null.
     * @type {string}
     * @memberof FlightSupportNextAction
     */
    reason: FlightSupportNextActionReasonEnum;
}


/**
 * @export
 */
export const FlightSupportNextActionActionEnum = {
    None: 'none',
    Investigate: 'investigate',
    WaitForRecovery: 'wait_for_recovery',
    ContactCustomer: 'contact_customer',
    FreshProviderRead: 'fresh_provider_read',
    AwaitManualApproval: 'await_manual_approval',
    Unknown: 'unknown'
} as const;
export type FlightSupportNextActionActionEnum = typeof FlightSupportNextActionActionEnum[keyof typeof FlightSupportNextActionActionEnum];

/**
 * @export
 */
export const FlightSupportNextActionOwnerEnum = {
    None: 'none',
    ApiSupport: 'api_support',
    Search: 'search',
    Customer: 'customer',
    Unknown: 'unknown'
} as const;
export type FlightSupportNextActionOwnerEnum = typeof FlightSupportNextActionOwnerEnum[keyof typeof FlightSupportNextActionOwnerEnum];

/**
 * @export
 */
export const FlightSupportNextActionReasonEnum = {
    TerminalOrHealthy: 'terminal_or_healthy',
    PersistedAttentionRequired: 'persisted_attention_required',
    PersistedRecoveryPending: 'persisted_recovery_pending',
    PersistedRecoveryExhausted: 'persisted_recovery_exhausted',
    ProviderConfirmationRequired: 'provider_confirmation_required',
    PersistedManualApprovalRequired: 'persisted_manual_approval_required',
    CompatibilityUnknown: 'compatibility_unknown'
} as const;
export type FlightSupportNextActionReasonEnum = typeof FlightSupportNextActionReasonEnum[keyof typeof FlightSupportNextActionReasonEnum];


/**
 * Check if a given object implements the FlightSupportNextAction interface.
 */
export function instanceOfFlightSupportNextAction(value: object): value is FlightSupportNextAction {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function FlightSupportNextActionFromJSON(json: any): FlightSupportNextAction {
    return FlightSupportNextActionFromJSONTyped(json, false);
}

export function FlightSupportNextActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSupportNextAction {
    if (json == null) {
        return json;
    }
    return {

        'action': json['action'],
        'owner': json['owner'],
        'reason': json['reason'],
    };
}

export function FlightSupportNextActionToJSON(json: any): FlightSupportNextAction {
    return FlightSupportNextActionToJSONTyped(json, false);
}

export function FlightSupportNextActionToJSONTyped(value?: FlightSupportNextAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'action': value['action'],
        'owner': value['owner'],
        'reason': value['reason'],
    };
}

